import api from '../axios/axiosInstance';

export interface shiftForm {
  ID: string;
  startDate: Date | string;
  startAmount: number;
}
export interface closeShiftForm {
  shiftId: string;
  endAmount: number;
}

const createShift = async (data: shiftForm): Promise<any> => {
  return api.post('/shifts', data);
};
const closeShift = async (data: closeShiftForm): Promise<any> => {
  return api.post('/shifts/close', data);
};

export { closeShift, createShift };
